import { Entity } from 'siren-parser';

export interface BinEntity extends Entity {
  properties: {
    name: string;
    role: 'ingredient' | 'feed';
    dimensions: BaseBinDimensions;
    volumes: BinVolumes;
  }
}

export type BinShape = 'circular' | 'rectangular';
export type BinProfile = 1 | 2;
export enum BinProfiles {
  CENTER = 1,
  SIDE = 2,
}
export type BinHatchType = 'top' | 'side';

export interface BaseBinDimensions {
  shape: BinShape;
  totalHeight: number;
}
export interface CircularBinDimensions extends BaseBinDimensions {
  shape: 'circular';
  profile: BinProfile;
  ringCount: number;
  lipHeight: number;
  deviceDepth: number;
  top: {
    truncatedRadius: number;
    angle: number;
    height: number;
  };
  body: {
    radius: number;
    height: number;
  };
  hopper: {
    height: number;
    angle: number;
    truncatedRadius: number;
  }
  hatchType: BinHatchType;
  sideHatch?: {
    radius: number;
    topDistance: number;
    devicePlacement: number;
  }
}

export interface BinVolumes {
  top: number;
  body: number;
  hopper: number;
  fullTotal: number;
  total: number;
}
